var _AsyncCacheItem_promiseOrValue, _AsyncCacheItem_expiryPolicy;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import isFunction from '../TypeHelpers/isFunction';
import { Promises } from '..';
export default class AsyncCacheItem {
    constructor(promiseOrValueOrFactory, expiryPolicy) {
        _AsyncCacheItem_promiseOrValue.set(this, void 0);
        _AsyncCacheItem_expiryPolicy.set(this, void 0);
        if (isFunction(promiseOrValueOrFactory)) {
            __classPrivateFieldSet(this, _AsyncCacheItem_promiseOrValue, promiseOrValueOrFactory(), "f");
        }
        else {
            __classPrivateFieldSet(this, _AsyncCacheItem_promiseOrValue, promiseOrValueOrFactory, "f");
        }
        __classPrivateFieldSet(this, _AsyncCacheItem_expiryPolicy, expiryPolicy, "f");
    }
    getValueAsync() {
        return new Promise((resolve, reject) => {
            (async () => {
                try {
                    const value = await Promises.ensurePromise(__classPrivateFieldGet(this, _AsyncCacheItem_promiseOrValue, "f"));
                    if (__classPrivateFieldGet(this, _AsyncCacheItem_expiryPolicy, "f").call(this, value)) {
                        reject();
                    }
                    else {
                        resolve(value);
                    }
                }
                catch (error) {
                    reject(error);
                }
            })();
        });
    }
}
_AsyncCacheItem_promiseOrValue = new WeakMap(), _AsyncCacheItem_expiryPolicy = new WeakMap();
